import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPolicyPage: React.FC = () => (
  <LegalPageLayout title="Privacy Policy" updated="August 14, 2026">
    <p>
      This Privacy Policy explains how Tangents LLC ("Bilt:Spec", "we") collects, uses, and shares information when you use
      biltspec.com and the Bilt:Spec mobile apps. It is a product-specific draft for legal review, not a compliance certification.
    </p>
    <h2>1. Data we collect</h2>
    <ul>
      <li>Account data: username, email, password hash, name, optional profile fields, invite codes.</li>
      <li>Vehicle and build data: identity, modifications, media metadata, public settings, collectibility signals.</li>
      <li>Events and payments: registrations, tickets, order metadata, Stripe identifiers (not full card numbers).</li>
      <li>Passport: encounters, scan metadata, optional location verification signals, campaign participation.</li>
      <li>Social graph: clubs, shops, contributors, favorites, watches.</li>
      <li>
        Device and usage: app/device info, push tokens, auth tokens in local/secure storage, and first-party product
        metrics (feature usage such as opening a Home feed item). Optional third-party analytics (for example Google
        Analytics, when configured) only run after you allow analytics in cookie preferences.
      </li>
      <li>Support and privacy requests you submit.</li>
    </ul>
    <h2>2. How we use data</h2>
    <p>
      We use data to operate accounts, show public builds you publish, run events and payments, deliver in-app notifications,
      send transactional email when enabled, prevent abuse, improve the product, and comply with law. Marketing email is
      optional and separate from required account messages.
    </p>
    <h2>3. Public versus private</h2>
    <p>
      Public build pages, usernames, and content you choose to publish are visible to others. Private settings, unpublished
      drafts, and Passport privacy controls limit sharing where offered.
    </p>
    <h2>4. Sharing</h2>
    <p>
      We share data with processors such as hosting, Stripe, and email providers as needed to run Bilt:Spec. We do not sell
      personal information for money. Contextual sponsorship may appear in-product. Third-party advertising pixels are not
      part of the current product design.
    </p>
    <h2>5. Cookies and similar technologies</h2>
    <p>
      Bilt:Spec primarily uses local storage for authentication and preferences rather than advertising cookies. Optional
      analytics and advertising storage is controlled by the cookie preference center. Global Privacy Control (GPC), when
      present, is treated as an opt-out of advertising storage. First-party product metrics used to operate and improve
      signed-in features are separate from optional third-party analytics. See the Cookie Policy.
    </p>
    <h2>6. Retention and deletion</h2>
    <p>
      Account deletion anonymizes profile fields and deactivates the account. Payment, event, fraud, and legal records may
      be retained as needed. Exact retention schedules require legal review.
    </p>
    <h2>7. Your rights</h2>
    <p>
      Depending on your location (for example CCPA/CPRA, Colorado privacy law, GDPR/UK GDPR), you may have rights to access,
      correct, delete, export, or opt out of certain processing. Use Settings → Privacy and data, or contact privacy@biltspec.com.
      Global Privacy Control (GPC) is treated as an opt-out of advertising/sale/share where that control is offered.
    </p>
    <h2>8. Children</h2>
    <p>Bilt:Spec is not intended for children under 13. We do not knowingly collect personal information from children under 13.</p>
    <h2>9. International users</h2>
    <p>
      Bilt:Spec is operated from the United States. If you access Bilt:Spec from elsewhere, your information may be processed in the U.S.
      Legal transfer mechanisms require counsel review where GDPR applies.
    </p>
    <h2>10. Contact</h2>
    <p>Tangents LLC · privacy@biltspec.com · legal@biltspec.com (mailboxes pending operational setup).</p>
  </LegalPageLayout>
);

export default PrivacyPolicyPage;
